import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Your Twitter bio sucks - I think I can fix it",
  "description": "",
  "published": "2011-07-07T00:00:00.000Z",
  "redirect_from": ["/blog/your-twitter-bio-sucks/swizec/1914"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Two weeks ago I moved to a different continent and I have to say, the biggest culture shock was my very own twitter stream. It's still the same stream, but with a 9 hours different timezone everything is so new and shiny and weird and strange and it feels like I don't know anybody!`}</p>
    <p>{`And I have to `}<em parentName="p">{`follow people`}</em>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/07/300px-Twitter_Inc_HQ.jpg",
        "alt": "Twitter Inc HQ",
        "title": "Twitter Inc HQ"
      }}></img></p>
    <p><em parentName="p">{`New people.`}</em></p>
    <p>{`Back home I already have a pretty busy stream and I don't really feel the need to follow people unless they're really anyone interesting. I also don't actually get to accidentally meet new people because I apparently already follow the majority of those who are active.`}</p>
    <p><em parentName="p">{`tl;dr --> if you hate buzzy lame twitter bios, `}<a parentName="em" {...{
          "href": "mailto:swizec@swizec.com?subject=long%20bios%20suck!"
        }}>{`send me an email`}</a></em></p>
    <p>{`But here in the US the situation is different. I feel like a newbie user. Stumbling upon cool people. Stumbling upon obnoxious marketers I haven't learned to ignore yet. Stumbling upon ... stuff.`}</p>
    {
      /*more*/
    }
    <p>{`It's almost like discovering the service anew.`}</p>
    <p>{`Except it's different.`}</p>
    <p>{`Very different.`}</p>
    <p>{`Now that I could claim that I'm not a newbie anymore (because I've been here all summer, for those who get the joke :P) ... I can actually see how horrible twitter is for discovering `}{`_`}{`cool `}{`_`}{`and `}{`_`}{`interesting `}{`_`}{`people.`}</p>
    <h2 {...{
      "id": "your-bio-sucks"
    }}>{`Your bio sucks`}</h2>
    <p>{`The problem is that everyone's bio looks something like this:`}</p>
    <blockquote>
      <p parentName="blockquote">{`'The king of cabaret noir' - The Metro. Gin addled vaudevillian musical reprobate. Smut peddler. Full time audience antagonist. Tweets about stuff.`}</p>
      <p parentName="blockquote">{`Social Business/Creative Technologist, Open & Social, Ex-MySpace (07-09), Dropping pooh sticks in the stream of consciousness. All opinions my own`}</p>
      <p parentName="blockquote">{`SQL Server MVP and C# developer. Creator of SSMS Tools Pack add-in for SSMS.`}</p>
    </blockquote>
    <p>{`And so on.`}</p>
    <p>{`It sucks. It suck donkey balls! These things don't tell me anything. Usually they're just a bunch of buzzwords that sound impressive to a drunk monkey on a Monday night. What I want on `}<a parentName="p" {...{
        "href": "http://twitter.com",
        "title": "Twitter"
      }}>{`Twitter`}</a>{` are `}<em parentName="p">{`people`}</em>{`. Actual, down to earth, people.`}</p>
    <p>{`People I can talk to, people I can make a real connection with.`}</p>
    <p>{`The bios aren't helping.`}</p>
    <p>{`To borrow the bio of @vanfranco -> "Writing a bio is like giving someone the best highlights of your career packed into a tiny space."`}</p>
    <p>{`It's not ... at least it shouldn't be!`}</p>
    <p>{`Why do you want to do that?`}</p>
    <p>{`The only reason you could possibly want to do that is because you don't know who you are. Don't have a good identity. And are probably boring to boot.`}</p>
    <h2 {...{
      "id": "the-true-gems-of-bios"
    }}>{`The true gems of bios`}</h2>
    <p>{`Let me share some of the best bios I've seen:`}</p>
    <blockquote>
      <p parentName="blockquote">{`I am a VC`}</p>
      <p parentName="blockquote">{`Superhero. World explorer.`}</p>
      <p parentName="blockquote">{`grinds Toni Braxton in Vegas`}</p>
      <p parentName="blockquote">{`a chihuahua with a split personality. bid on ebay.`}</p>
    </blockquote>
    <p>{`Short. To the point. Makes me want to follow these people immediately. They look like they know where they're going, the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Somebody_Else%27s_Problem",
        "title": "Somebody Else's Problem"
      }}>{`SEP field`}</a>{` doesn't work on them ... these are the people I want to talk to. The kind of people I want to hang out with!`}</p>
    <p>{`And I'm sure many of you are the same. We like people who aren't afraid of who they really are.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/07/300px-Twttr_sketch-Dorsey-2006.jpg",
        "alt": "Sketch for Twitter. See also the author's desc...",
        "title": "Sketch for Twitter. See also the author's desc..."
      }}></img></p>
    <h2 {...{
      "id": "the-solution"
    }}>{`The solution?`}</h2>
    <p>{`Here's my idea for solving this problem.`}</p>
    <p>{`On one hand you want to have a short and simple bio. Something that tells exactly one thing about you.`}</p>
    <p>{`On the other, there's more to yourself than a single identifying thing. And you want to list all of them.`}</p>
    <p>{`What if there was a service that let you enter several short facts about yourself. It would then pick a random short fact every couple of days and change your bio. This way every time some new person looks at your profile, you look like you know what you're doing, but at the same time you get to keep all the variety and information.`}</p>
    <p>{`I'm proposing to build this service. All I need to know now is if anyone else besides me would want to use it :)`}</p>
    <p>{`Send me an email to `}<a parentName="p" {...{
        "href": "mailto:swizec@swizec.com?subject=long%20bios%20suck!"
      }}>{`swizec@swizec.com`}</a>{` if you think this is a good idea. Thanks!`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://babyfruit.typepad.com/mediagirl/2011/07/12-most-compelling-reasons-i-do-not-follow-everyone-back.html"
        }}>{`12 Most Compelling Reasons I Do Not Follow Everyone Back`}</a>{` (babyfruit.typepad.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://holykaw.alltop.com/8-words-to-never-put-in-your-twitter-bio"
        }}>{`8 words to never put in your Twitter bio`}</a>{` (holykaw.alltop.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blazingminds.co.uk/write-twitter-bio-gains-followers/"
        }}>{`How To Write a Twitter Bio That Gains You More Followers`}</a>{` (blazingminds.co.uk)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://jtdabbagian.com/2011/05/3-steps-to-creating-an-effective-twitter-bio/"
        }}>{`3 Steps to Creating an Effective Twitter Bio`}</a>{` (jtdabbagian.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=54bca522-1101-4c1a-8d21-245d006ac73c",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      